import React from 'react';
import GooglePlaceAutocomplete from '../../components/GooglePlaceAutocomplete';
import {
    isValidApartmentWithSpace,
    normalizeMobile,
    normalizeZipCode,
    renderCheckBox,
    renderTextArea,
  } from '../../components/reduxFields';
  import {
    Field,
  } from 'redux-form';

import Tooltip from '../../components/Tooltip';

export default function InsuranceCollapse({
    patientInsuranceId,
    removeRow,
    insurance,
    patientMasterData,
    _getLastSelectedFormIndexByCompanyTypeName,
    renderAutoCompleteSingleSelect,
    renderTextField,
    renderDateField,
    getMinDate,
    isDisable,
    onDateChange,
    cardIssueDate,
    selectorInsuranceDetail,
    isValidNameWithSpace,
    isValidName,
    handleNewRequest,
    masterGender,
    relationship,
    isValidAddress,
    InsuredPersonsAddressList,
    insuranceType,
    GetFullAddress,
    handleNewRequestForInsuranceCompany,
    insurancePersonSameAsPatient,
    filedName,
    filedName2,
    selectedInsuredPerson,
    relationshipTypeObj,
    masterCountry,
    masterState,
    index,
    tooltipValue,
    cardIssueDateFromInsuranceState,
    cardIssueEndDateFromInsuranceState,
    previousInsuranceExpDate,
    isNewInsurance
}) {

  let prevDateExp;
  if(previousInsuranceExpDate){
    let date = new Date(previousInsuranceExpDate);
    let date2 = new Date(date);
    prevDateExp = !isNewInsurance && new Date(date2.setDate(date.getDate()+1))
  }
  
  
  return (
    <div key={index}>
      { index > 0 && insuranceType==='primary' ?
        (<div className="row">
          <div className="col-sm-6">
            <div className="panel_title">
              <h3>Additional Primary Insurance Detail</h3>
              <i className="flaticon flaticon-medical-2"></i>
              {!patientInsuranceId ?
                (<div className="additionalAddressBtn">
                  <button className="addnum" type="button" title="Remove Insurance" onClick={() => removeRow(index)}>
                    <i className="fa fa-minus-square redfont" aria-hidden="true"></i>
                  </button>
                </div>)
                : null}
            </div>
          </div>
        </div>)
        : null
      }
      { index > 0 && insuranceType==='secondary' ?
        (<div className="row">
          <div className="col-sm-6">
            <div className="panel_title">
              <h3>Additional Secondary Insurance Detail</h3>
              <i className="flaticon flaticon-medical-2"></i>
              {/* patientInsuranceId */}
              {!patientInsuranceId?
                (<div className="additionalAddressBtn">
                  <button className="addnum" type="button" title="Remove Insurance" onClick={() => removeRow(index)}>
                    <i className="fa fa-minus-square redfont" aria-hidden="true"></i>
                  </button>
                </div>)
                : null}
            </div>
          </div>
        </div>)
        : null
      }
      <div className="row">
        <div className="col-sm-4 require mt-35">
          <Field
            name={`${insurance}.insuranceCompanyID`}
            label="Insurance Company"
            disabled={patientInsuranceId ? true : false}
            options={patientMasterData && patientMasterData.insuranceCompanies ? patientMasterData.insuranceCompanies : []}
            handleNewRequest={(input,selectedRecord)=>handleNewRequestForInsuranceCompany(input, selectedRecord, filedName, filedName2,insurance,index)}
            component={renderAutoCompleteSingleSelect} />
        </div>
        <div className="col-sm-8">
          <Field
            name={`${insurance}.insuranceCompanyAddress`}
            type="text"
            maxLength="55"
            label="Insurance Company Address"
            normalize={isValidNameWithSpace}
            disabled={true}
            fullWidth={true}
            component={renderTextField} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <Field
            name={`${insurance}.carrierPayerID`}
            type="text"
            maxLength="100"
            disabled={true}
            label="Carrier Payer ID"
            component={renderTextField} />
        </div>
        <div className={`${insuranceType==='secondary'&&index>0?"col-sm-4 require":"col-sm-4"}`} style={{position:"relative",zIndex:"20"}}>
          { (tooltipValue && tooltipValue === "invalid")?
            (
              <span style={{position:"absolute",bottom: "42px", left: "-116px"}}>
                <Tooltip Description={"Please enter the issue date and expiration date for the previously added insurance with the same name."} />
              </span>
            ):null 
          }
          <Field
            name={`${insurance}.cardIssueDate`}
            placeholder="Insurance Issue Date"
            component={renderDateField}
            openToYearSelection={true}
            locale="en-US"
            minDate={getMinDate || prevDateExp}
            disabled={isDisable||(index==0 && insuranceType==='secondary')}
            // maxDate={new Date()}
            selected={(cardIssueDateFromInsuranceState
              // && this.getNextDay(selectorInsuranceDetail[index].cardIssueDate)
              ) || null}
            onDateChange={onDateChange}
            
             />
        </div>
        <div className="col-sm-4 ">
          <Field
            name={`${insurance}.cardIssueEndDate`}
            placeholder="Insurance Expiry date"
            component={insuranceType==="secondary"?renderDateField:renderDateField}
            openToYearSelection={true}
            locale="en-US"
            disabled={insuranceType==="secondary"?true:isDisable}
            minDate ={cardIssueDate || cardIssueDateFromInsuranceState || prevDateExp || null}
            // maxDate={new Date()}
            selected={(cardIssueEndDateFromInsuranceState) || null}    
            onDateChange={onDateChange} />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <Field
            name={`${insurance}.insuranceGroupName`}
            type="text"
            normalize={isValidNameWithSpace}
            maxLength="30"
            label="Insurance Group Name/Number"
            component={renderTextField} />
        </div>
        <div className="col-sm-4">
          <Field
            name={`${insurance}.insurancePlanName`}
            type="text"
            normalize={isValidNameWithSpace}
            maxLength="50"
            label="Insurance Plan Name"
            component={renderTextField} />
        </div>
        <div className="col-sm-4 require">
          <Field
            name={`${insurance}.insuranceIDNumber`}
            type="text"
            normalize={isValidNameWithSpace}
            maxLength="20"
            label="Insurance ID Number"
            component={renderTextField} />
        </div>
      </div>
      <div className="row">  
        <div className="col-sm-4">
          <Field
            name={`${insurance}.notes`}
            type="text"
            maxLength="100"
            label={`${(insuranceType || '').charAt(0).toUpperCase() + (insuranceType || '').substr(1)} Insurance Notes`}
            fullWidth={true}
            component={renderTextField} />
        </div>                
        <div className="col-sm-4 mt-35">
          <Field
            name={`${insurance}.authorizedReleasedSignatureId`}
            label="Authorized Release (Box 12)" 
            options={patientMasterData && patientMasterData.signatureOnFile ? patientMasterData.signatureOnFile : []}
            handleNewRequest={(input, selectedRecord) => handleNewRequest(input, selectedRecord, insurance)}
            component={renderAutoCompleteSingleSelect} />
        </div>
        <div className="col-sm-4">
          <Field
            name={`${insurance}.authorizedReleasedDate`}
            placeholder="Date Of Signature"
            component={renderDateField}
            openToYearSelection={true}
            locale="en-US"
            maxDate={new Date()}
            selected={(selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].authorizedReleasedDate) || new Date()}
            onDateChange={onDateChange} />
        </div>                 
      </div> 
      <div className="row">
        <div className="col-sm-4 mt-35">
          <Field
            name={`${insurance}.authorizedPaymentSignatureId`}
            label="Authorized Payment (Box 13)"     
            options={patientMasterData && patientMasterData.signatureOnFile ? patientMasterData.signatureOnFile : []}
            handleNewRequest={(input, selectedRecord) => handleNewRequest(input, selectedRecord, insurance)}
            component={renderAutoCompleteSingleSelect} />
        </div>

        {insuranceType !== 'tertiary' ? <div className="col-sm-4 mt-33">
          <Field
            name={`${insurance}.additionalClaimInformationBox19`}
            label="Additional Claim Information (Box 19)"
            type="text"
            component={renderTextField} 
            maxLength='60'
            />
        </div> : null}      
          
      </div>
      <div className="row">
        <div className="col-sm-12 custm_clientinsurance">
          <span>If "No Signature on File" is selected for Box 12 and/or 13 then claims may be denied. Please make sure you have all necessary signatures on file prior to submission of claims.</span>
        </div>
      </div>
      <div className="row">                  
        <div className="col-sm-12 mt-20 custm_clientinsurance">
          <Field
              name={`${insurance}.doNotAcceptAssignment`}
              label='Do Not Accept Assignment (Box 27)'
              component={renderCheckBox}
            />
            <span>(If "Do Not Accept Assignment" is checked then Theralytics will select “No” for Box 27. This box should not be checked unless payment should go to the client instead of your organization.)</span>
        </div>                  
      </div>
      <div className="row">                  
        <div className="col-sm-12">
          <Field
            name={`${insurance}.insuranceNotes`}                      
            type="text"
            fullWidth={true}
            label="Insurance Notes"
            // autoHeight={true}                      
            component={renderTextArea}                      
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-6 custm_clientinsurance">
          <Field
            name={`${insurance}.insurancePersonSameAsPatient`}
            label='Insured Person is the same person as the Client'
            component={renderCheckBox}
          />
          <span>(If this box is checked then Theralytics will select "Self" in box 6 of the CMS 1500 form.)</span>
        </div>
        <div className="col-sm-6 custm_clientinsurance">
          <Field
              name={`${insurance}.hiddenForFutureTransactions`}
              label='Delete Insurance'
              component={renderCheckBox}
            />
            <span>(Please make sure to end any existing authorizations with this payer. This payer will no longer be available once this box is checked and saved.)</span>
        </div>
      </div>               
      {!insurancePersonSameAsPatient ?
        <div>
          <div className="panel_title">
            <i className="flaticon flaticon-shield"></i>
            <h3>Insured person {insurancePersonSameAsPatient} </h3>
          </div>
          <div className="row">
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.firstName`}
                type="text"
                maxLength="40"
                normalize={isValidName}
                label="First Name"
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${insurance}.insuredPerson.middleName`}
                type="text"
                maxLength="40"
                normalize={isValidName}
                label="Middle Name"
                component={renderTextField} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.lastName`}
                type="text"
                maxLength="40"
                normalize={isValidName}
                label="Last Name"
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name={`${insurance}.insuredPerson.genderID`}
                label="Gender"
                handleNewRequest={handleNewRequest}
                options={masterGender}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.dob`}
                placeholder="Date of birth"
                component={renderDateField}
                openToYearSelection={true}
                locale="en-US"
                maxDate={new Date()}
                selected={(selectedInsuredPerson && selectedInsuredPerson.dob) || null}
                onDateChange={onDateChange} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.phone`}
                type="text"
                maxLength="14"
                label="Mobile"
                component={renderTextField}
                normalize={normalizeMobile} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name={`${insurance}.insuredPerson.patientRelationshipBox6Id`}
                label="Relationship Status (Box 06)"     
                options={patientMasterData && patientMasterData.insuredPersonRelationship ? patientMasterData.insuredPersonRelationship : []}
                handleNewRequest={handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name={`${insurance}.insuredPerson.relationshipID`}
                label="Relationship"
                handleNewRequest={handleNewRequest}
                options={relationship}
                component={renderAutoCompleteSingleSelect} />
            </div>
            {
              relationshipTypeObj && relationshipTypeObj.value && relationshipTypeObj.value.toUpperCase() === 'OTHER' ?
                <div className="col-sm-4 require">
                  <Field
                    name={`${insurance}.insuredPerson.otherRelationshipName`}
                    label='Mention Other Relationship'
                    component={renderTextField}
                  />
                </div>
                : null
            }
          </div>
          <div className="row">
            <div className="col-sm-8 require">
              <GooglePlaceAutocomplete
                getFullAddress={(componentForm) => GetFullAddress(componentForm, index)}
                id={`${insurance}.insuredPerson.Address`}
                labelText="Address"
                errorText={isValidAddress ? '' : 'Please enter address.'}
                value={InsuredPersonsAddressList && InsuredPersonsAddressList[index] && InsuredPersonsAddressList[index].address}
              />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${insurance}.insuredPerson.apartmentNumber`}
                type="text"
                maxLength='15'
                label="Apt/Unit"
                normalize={isValidApartmentWithSpace}
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name={`${insurance}.insuredPerson.countryID`}
                label="Country"
                options={masterCountry}
                handleNewRequest={(input, selectedRecord) => handleNewRequest(input, selectedRecord, insurance)}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.city`}
                type="text"
                maxLength="50"
                normalize={isValidNameWithSpace}
                label="City"
                component={renderTextField} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name={`${insurance}.insuredPerson.stateID`}
                label="State"
                disabled={!(selectedInsuredPerson && selectedInsuredPerson.countryID)}
               // options={this.state.filteredStatesByCountry[index]}
                options={masterState.filter((obj) => obj.countryID === 1)}                         
                handleNewRequest={handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require">
              <Field
                name={`${insurance}.insuredPerson.zip`}
                type="text"
                maxLength="10"
                normalize={normalizeZipCode}
                label="Zip"
                component={renderTextField} />
            </div>
          </div>
        </div>
        : ''}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/patients/InsuranceCollapse.js